
  function initCustomCollectionSlider(section) {
    const slider = section.querySelector('.custom-collection-splide');
    if (!slider || slider.classList.contains('is-initialized')) return;

    slider.classList.add('is-initialized');

    new Splide(slider, {
      type: 'loop',
      perPage: 4,
      gap: '24px',
      pagination: false,
      arrows: true,
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 },
        480: { perPage: 1 },
      },
    }).mount();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.custom-collection-list')
      .forEach(initCustomCollectionSlider);
  });

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('.custom-collection-list');
    if (section) initCustomCollectionSlider(section);
  });

